import React, { Component } from 'react';
import { connect } from 'react-redux';

import { answerQuestion } from '../../../../../_actions/questionnaire.actions';

class Choice extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: []
    }

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const isChecked = e.target.checked;
    let selected = this.state.selected;

    const itemControl = this.props.question.extension.find((extension) => {
      return extension.url === "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl"
    });

    if (isChecked) {
      if (itemControl.valueCodeableConcept.coding[0].code === 'check-box') {
        selected.push(e.target.value);
      } else {
        selected = new Array(e.target.value)
      }
    } else {
      if (itemControl.valueCodeableConcept.coding[0].code === 'check-box') {
        selected.splice(selected.indexOf(e.target.value), 1);
      } else {
        selected = [];
      }
    }

    this.props.dispatch(answerQuestion(this.props.question, selected));

    this.setState({ selected });
  }

  render() {
    const { question } = this.props;

    const itemControl = question.extension.find((extension) => {
      return extension.url === "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl"
    });

    const choiceType = itemControl.valueCodeableConcept.coding[0].code === 'check-box' ? 'checkbox' : 'radio';

    return <>
      <h6 className="card-title">{question.text || 'Enter your question.'}</h6>

      {question.answerOption.length === 0 &&
        <strong>No options...</strong>
      }

      {question.answerOption.map((option, i) => {
        return <div key={i} className="form-check">
          <input
            onClick={this.handleClick}
            id={`choice_${question.linkId}_${i}`}
            name={`choice_${question.linkId}`}
            className="form-check-input"
            type={choiceType}
            value={option.valueCoding.code}
          />

          <label
            htmlFor={`choice_${question.linkId}_${i}`}
            className="form-check-label"
          >{option.valueCoding.code}</label>
        </div>
      })}
    </>;
  }
}

export default connect()(Choice);